import React from 'react'
import { TStory } from './types'

export const StoryContext = React.createContext<TStory | undefined>(undefined)

export const useStoryContext = () => {
  const context = React.useContext(StoryContext)
  if (context === undefined) {
    throw new Error('useStoryContext must be used within a StoryContainer or StoryContext provider')
  }
  return context
}
